import { render, staticRenderFns } from "./TabsGoodsSelector.vue?vue&type=template&id=a95bcab2&scoped=true&"
import script from "./TabsGoodsSelector.vue?vue&type=script&lang=js&"
export * from "./TabsGoodsSelector.vue?vue&type=script&lang=js&"
import style0 from "./TabsGoodsSelector.vue?vue&type=style&index=0&id=a95bcab2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95bcab2",
  null
  
)

export default component.exports